<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  <div class="divShadow">
    <form class="form-horizontal" novalidate>

      <!-- Loader -->
      @if (showFormLoader) {
<div class="formLoader">
        <i class="fa fa-spinner fa-spin gt-refresh"></i>
      </div>
}

      <!-- Form Content -->
      @if (!showFormLoader) {
<div class="form-content">
        <div class="form-row">
          <!-- Local Acct Field (readonly) -->
          <div class="col-md-3">
            <label>Local Acct:</label>
            <input type="text"
                   class="form-control"
                   name="firLocalAcct"
                   [ngModel]="firLocalAcctDetail.LOCAL_ACCT"
                   readonly>
          </div>

          <!-- Local Account Desc Field (editable) -->
          <div class="col-md-6">
            <label>Local Account Desc:</label>
            <textarea class="form-control input-sm"
                      name="firLocalAcountDescInput"
                      [(ngModel)]="firLocalAcctDetail.LOCAL_ACCT_DESC_NEW"
                      (ngModelChange)="onDescriptionChange()"
                      required
                      maxlength="100"
                      rows="3"></textarea>
            <br>

            <!-- Validation Messages -->
            @if (isFormDirty && (!firLocalAcctDetail.LOCAL_ACCT_DESC_NEW || firLocalAcctDetail.LOCAL_ACCT_DESC_NEW.trim() === '')) {
<span
                  class="validation">Local Account Desc is required!</span>
}
            @if (firLocalAcctDetail.LOCAL_ACCT_DESC_NEW && firLocalAcctDetail.LOCAL_ACCT_DESC_NEW.length > 100) {
<span
                  class="validation">Local Account Desc is too long!</span>
}
          </div>
        </div>
      </div>
}

    </form>
  </div>
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button"
          type="button"
          [disabled]="isSaveClicked || !isFormValid"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>

  <button class="reset-button"
          type="button"
          (click)="reset()">Reset</button>

  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>


